import { render, staticRenderFns } from "./inquiry.vue?vue&type=template&id=3544f868&scoped=true&"
import script from "./inquiry.vue?vue&type=script&lang=js&"
export * from "./inquiry.vue?vue&type=script&lang=js&"
import style0 from "./inquiry.vue?vue&type=style&index=0&id=3544f868&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3544f868",
  null
  
)

export default component.exports